import Box from '@mui/material/Box';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { collectEvent } from 'clients/MonitorClient';
import { SUBSTITUTE_RECOMMEND_ICON } from 'constants/Images';
import { useAuth } from 'context/Auth';
import { useCartSuggestions } from 'context/Cart/CartSuggestionContext';
import { useRouter } from 'next/router';
import { memo, useEffect, useState } from 'react';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import { mapScreenToEnum, mapSourceToEnum, MONITORING_COLLECTOR_TYPE } from 'utils/MonitorUtils';
import gtag from 'utils/gtag';
import styles from './ComboSuggestion.module.css';

export const COMBO_SUGGESTED_BY = 'comboSuggestedBy';
const SLIDE_TIMEOUT = 5000;

function ComboSuggestion({ skuProduct }) {
  const { comboSuggestions } = useCartSuggestions();
  const [isGATracked, setIsGATracked] = useState(false);
  const { user } = useAuth();
  const router = useRouter();

  const suggestions = comboSuggestions?.[skuProduct.skuCode] || [];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (suggestions.length <= 1) return;

    const interval = setInterval(() => {
      setActiveIndex((activeIndex) => (activeIndex + 1) % suggestions.length);
    }, SLIDE_TIMEOUT);

    return () => clearInterval(interval);
  }, [suggestions.length]);

  if (!suggestions.length) return <></>;

  function handleClick(suggestion) {
    gtag.clickComboSuggestionMore({ user, skuProduct, comboSKUCode: suggestion.skuCode });
    router.push(`${suggestion.url}?${COMBO_SUGGESTED_BY}=${skuProduct.slug}`);

    collectEvent(MONITORING_COLLECTOR_TYPE.CLICK_BUY_MORE_BUTTON, {
      combo: suggestion.skuCode,
      sku: skuProduct.skuCode,
      sellerId: skuProduct.sellerId,
      productId: skuProduct.productId || skuProduct.id,
      source: mapSourceToEnum(),
      screen: mapScreenToEnum(),
      content: 'Click nút Săn ngay hoặc Card Combo gợi ý',
    });
  }

  function handleMouseOver() {
    if (isGATracked) return;

    gtag.impressionComboSuggestion({ user, skuProduct });
    setIsGATracked(true);

    collectEvent(MONITORING_COLLECTOR_TYPE.KEY_SKU_IMPRESSION, {
      sku: skuProduct.skuCode,
      seller_id: skuProduct.sellerId,
      product_id: skuProduct.productId || skuProduct.id,
      source: mapSourceToEnum(),
      screen: mapScreenToEnum(),
      content: 'View SKU được đề xuất Combo gợi ý',
    });
  }

  return (
    <div className={styles.comboSuggestionContainer}>
      {suggestions.map((suggestion, index) => (
        <Box
          key={suggestion.skuCode}
          display="flex"
          alignItems="center"
          gap={'8px'}
          padding={1}
          className={`${styles.comboSuggestion} ${index === activeIndex ? styles.active : ''}`}
          onClick={() => handleClick(suggestion)}
          onMouseEnter={handleMouseOver}
        >
          <Box display="flex" alignItems="center" minWidth={32}>
            <ImageFallbackStatic src={SUBSTITUTE_RECOMMEND_ICON} height={32} width={32} />
          </Box>

          <div className={styles.suggestionLabel}>{suggestion.label}</div>

          <SuggestionContent suggestion={suggestion} />

          <Box display="inline-flex" alignItems="center" gap={'4px'} className={styles.suggestionLink}>
            <a>Săn ngay</a>

            <ChevronRightIcon className={styles.suggestionLinkChevron} />
          </Box>
        </Box>
      ))}
    </div>
  );
}

function SuggestionContent({ suggestion }) {
  let content = suggestion.content;

  if (suggestion.param) {
    Object.entries(suggestion.param).forEach(([key, value]) => {
      content = content.replaceAll(`{${key}}`, `<span class="${styles[key]}">${value}</span>`);
    });
  }

  return <div className={styles.suggestionContent} dangerouslySetInnerHTML={{ __html: content }} />;
}

export default memo(ComboSuggestion);
